import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
} from '@angular/core';
import { UiTabbarItem } from '../../types/ui-tabbar-item.interface';

@Component({
  selector: 'ui-tabbar',
  imports: [],
  templateUrl: './ui-tabbar.component.html',
  styleUrl: './ui-tabbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTabbarComponent {
  public readonly items: InputSignal<readonly UiTabbarItem[]> = input.required<readonly UiTabbarItem[]>();
  public readonly activeItemId: InputSignal<string> = input.required<string>();
  public readonly ariaLabel: InputSignal<string> = input<string>('Primary navigation');
  public readonly activeItemIdChange: OutputEmitterRef<string> = output<string>();

  protected handleItemSelected(item: UiTabbarItem): void {
    if (item.disabled === true) {
      return;
    }

    this.activeItemIdChange.emit(item.id);
  }
}
